<template>
    <div class="common_left_submenuClass">
        <el-submenu
            v-if="menu.children && menu.children.length >= 1"
            :index="menu.uuid" class="menuChildCLass">
            <template slot="title">
                <span>{{ menu.name }}</span>
            </template>
            <sub-menu
                v-for="item in menu.children"
                :key="item.uuid"
                :menu="item">
            </sub-menu>
        </el-submenu>
        <el-menu-item v-else :index="menu.uuid" @click="navMenuClick(menu)">
        <span slot="title">
            {{ menu.name }}
        </span>
        </el-menu-item>
    </div>
</template>

<script>
    import SubMenu from './common_left_submenu'
    export default {
        name: 'sub-menu',
        data() {
            return {
                menuId: ''
            }
        },
        props: {
            menu: {
                type: Object,
                required: true
            }
        },
        components: {
            SubMenu
        },
        computed: {},
        methods: {
            navMenuClick(val){
                if(val.url){
                    this.$router.push(val.url)
                    this.resetSetItem('menuActiveId',val.uuid)
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .common_left_submenuClass{
        /deep/ .menuitem {
            padding: 0;
        }
    
        /deep/ .el-menu-item {
            padding: 0 !important;
        }
    
        /deep/ .el-submenu__title {
            padding: 0 !important;
            height: inherit;
            line-height: 40px;
        
            &:hover {
                background-color: #fff;
            }
        }
    
        /deep/ .el-menu-item:focus, .el-menu-item:hover {
            background-color: #fff;
            color: #3686D7;
        }
        /deep/ .el-menu-item {
            height: inherit;
            line-height: 40px;
        }
    
        /deep/ .el-submenu__icon-arrow {
            right: -6px;
            margin-top: -8px;
            font-size: 14px;
        }
    
        .subMenuName {
            font-size: 14px;
            cursor: pointer;
        
            &:hover {
                color: #3686D7;
            }
        }
        /deep/.el-menu-item.is-active{
            color: #3686D7;
        }
        .menuChildCLass {
            /deep/.el-menu-item{
                min-width: 80px;
                height: 40px;
                font-size: 12px;
                border-radius: 4px;
                color: #666666;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                &.is-active{
                    background: #f3f7ff;
                    color: #3686D7;
                }
                &:hover {
                    color: #3686D7;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/common_left_submenu.vue